export default __webpack_public_path__ + "static/stavien-sinovialna-stava-header-bba876b5d76165b27b64804b5190e377.jpg";